import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { iAxios } from "../../../lib/utils";
import { alertMessage } from "../../../lib/actions";
import { GenericForm } from "../../common/GenericForm";

const ZohoFormConfig = [{
    name: 'zohoClientId',
    label: 'Zoho Client Id',
}, {
    name: 'zohoClientSecret',
    label: 'Zoho Client Secret',

}, {
    name: 'zohoCode',
    label: 'Zoho Code',
}, {
    name: 'zohoServer',
    label: 'Mult DC Accounts Server',
}]

export const ZohoConnect = ({ integrations, loadData }) => {

    const dispatch = useDispatch();
    const [mode, setMode] = useState('connected');
    const [zohoConnection, setZohoConnection] = useState(null);

    useEffect(() => {
        const con = integrations.find(item => item.refId === 'zoho-admin-integration' || item.name === 'zoho-integration');
        setZohoConnection(con);
    }, [integrations])

    const syncEmployees = () => {
        iAxios.post('/api/v1/admin/zoho-sync-employees').then(resp => {
            dispatch(alertMessage(`${resp.data.data.length} employee data synced successfully`));

        }).catch(ex => {
            alertMessage('Error while syncing emplyee data.Please try after sometime', 'Zoho Sync Error', 'ds-tone-bad');
        });
    }


    const syncLeaves = () => {
        iAxios.get('/api/v1/admin/zoho-sync-leaves').then(resp => {
            const { data, created } = resp.data;
            dispatch(alertMessage(`Employee leaves records synced : ${data.length} , New records created: ${created.length}`));
        }).catch(ex => {
            alertMessage('Error while syncing emplyee data.Please try after sometime', 'Zoho Sync Error', 'ds-tone-bad');
        });
    }

    const handleZohoAdminConnect = (data) => {
        iAxios.post('/api/v1/admin/zoho-connect', data).then(resp => {
            const data = resp.data;
            if (!data.success) {
                dispatch(alertMessage(data.message, 'Zoho Connect Error', 'ds-tone-bad'));
                return;
            }
            dispatch(alertMessage('Successfull Connected', 'Zoho Connect', 'ds-tone-good'));
            loadData();
        });
    }

    return <div className="ds-panel">
        <h3>Zoho People</h3>
        <div className="integ-lede">Integrate employee details, team structure and attendance management with Zoho.</div>
        <div className="ds-field-row" style={{ marginBottom: mode === 'open' ? 'var(--ds-space-5)' : 0 }}>
            {zohoConnection && <button className="ds-btn is-soft" onClick={syncEmployees}>Fetch employee data</button>}
            {zohoConnection && <button className="ds-btn is-soft" onClick={syncLeaves}>Sync leave data</button>}
            {mode !== 'open' && <button type="button" onClick={() => setMode('open')}
                className="ds-btn is-primary" style={{ marginLeft: 'auto' }}>Reconnect Zoho</button>}
        </div>
        {mode === 'open' && <div>
            <div className="integ-lede">
                For Zoho integration, perform the following steps:
                <ol>
                    <li>Go to the Zoho <a target="_blank" rel="noreferrer" href="https://api-console.zoho.com/">API Console</a></li>
                    <li>Create a self client</li>
                    <li>Paste the scope below into the Scope field</li>
                    <li>Select duration as 10 min</li>
                    <li>Once the code is generated, paste Code, Client Id and Client Secret below</li>
                    <li>Replace "api-console" in your API Console URL with "accounts" to get the Multi-DC Account Server</li>
                </ol>
                <textarea className="ds-input" rows="4" style={{ width: '100%', height: '80px', padding: 'var(--ds-space-2)' }} disabled defaultValue="ZOHOPEOPLE.attendance.ALL,ZOHOPEOPLE.leave.ALL,ZOHOPEOPLE.dashboard.ALL,ZOHOPEOPLE.employee.ALL,ZOHOPEOPLE.forms.ALL,aaaserver.profile.READ" />
            </div>

            <GenericForm fields={ZohoFormConfig}
                wrapClass='ds-form-field'
                onSubmit={handleZohoAdminConnect}
                onCancel={() => setMode('connected')}
                initVals={{
                    zohoServer: 'https://accounts.zoho.com',
                    zohoClientId: zohoConnection ? zohoConnection.data.input.zohoClientId : '',
                    zohoClientSecret: zohoConnection ? zohoConnection.data.input.zohoClientSecret : ''
                }}
                submitLabel="Connect Zoho"
                fieldClass='ds-input' />
        </div>}
    </div>;

}
